import {
  DASHBOARD_REQUEST,
  DASHBOARD_SUCCESS,
  DASHBOARD_FAILURE,
  CHART_REVIEW_QUEUE_REPORT_REQUEST,
  CHART_REVIEW_QUEUE_REPORT_SUCCESS,
  CHART_REVIEW_QUEUE_REPORT_FAILURE,
  DASHBOARD_LOCATIONS_REQUEST,
  DASHBOARD_LOCATIONS_SUCCESS,
  DASHBOARD_LOCATIONS_FAILURE,
  DASHBOARD_CLIENTS_REQUEST,
  DASHBOARD_CLIENTS_SUCCESS,
  DASHBOARD_CLIENTS_FAILURE
} from './DashboardActions';

const initialState = {
  data: null,
  error: null,
  isLoading: false,
  report: null,
  isReportLoading: false,
  locations: null,
  clients: null
};

export default function dashboardReducer(
  state = initialState,
  { type, payload },
) {
  switch (type) {
    case DASHBOARD_REQUEST:
      return { ...state, isLoading: true };
    case DASHBOARD_SUCCESS:
      return { ...state, data: payload.data, error: null, isLoading: false };
    case DASHBOARD_FAILURE:
      return { ...state, error: payload.error, isLoading: false };

    case CHART_REVIEW_QUEUE_REPORT_REQUEST:
      return { ...state, isReportLoading: true };
    case CHART_REVIEW_QUEUE_REPORT_SUCCESS:
      return { ...state, report: payload.data, error: null, isReportLoading: false };
    case CHART_REVIEW_QUEUE_REPORT_FAILURE:
      return { ...state, error: payload.error, isLoaisReportLoadingding: false };

    case DASHBOARD_LOCATIONS_REQUEST:
      return { ...state, isLoading: true };
    case DASHBOARD_LOCATIONS_SUCCESS:
      return { ...state, locations: payload.data, error: null, isLoading: false };
    case DASHBOARD_LOCATIONS_FAILURE:
      return { ...state, error: payload.error, isLoading: false };

    case DASHBOARD_CLIENTS_REQUEST:
      return { ...state, isLoading: true };
    case DASHBOARD_CLIENTS_SUCCESS:
      return { ...state, clients: payload.data, error: null, isLoading: false };
    case DASHBOARD_CLIENTS_FAILURE:
      return { ...state, error: payload.error, isLoading: false };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/dashboard/DashboardReducer.js